<template>
  <div
    class="role-item"
  >
    <span class="role-text">{{ data.rolename }}</span><span
      class="role-text-event"
      @click="handleManage(data)"
    >{{ $t('message["413"]') }} </span>
    <span class="switch-span">
      <a-switch
        :checked="data.status===1"
        :disabled="data.system_role===1"
        @change="onChange($event,data,index)"
      />
      <span
        v-if="data.status===1"
        class="switch-text-span"
      >{{ $t('message["1466"]') }}</span>
      <span
        v-else
        class="switch-text-span"
      >{{ $t('message["1474"]') }}</span>
    </span>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleManage (e, type) {
      this.$emit('manage', e, type)
    },
    onChange (e, item, index) {
      this.$emit('change', { val: e, item, index })
    }
  }
}
</script>

<style scoped lang="scss">
.role-item {
  height: 48px;
  border-top: solid 1px rgba(235, 235, 235, 1);
  font-size: 14px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  line-height: 48px;
  color: rgba(51, 51, 51, 1);
  &:last-child {
    border-bottom: solid 1px rgba(235, 235, 235, 1);
  }

  .role-text {
    width: 120px !important;
    margin-right: 80px;
    display: inline-block;
  }
  .role-text-event {
    color: rgba(80, 119, 170, 1) !important;
    cursor: pointer;
    display: inline-block;
  }
  .switch-span {
    float: right;
    margin-right: 12px;
    .switch-text-span {
      font-weight: 400;
      margin-left: 4px;
    }
  }
}
</style>
